/**
 * InlineHelp — a small "?" affordance next to an attribute label, showing
 * schema-documentation text (what the concept means, not the instance's
 * value) via the browser's native title tooltip. No new CSS/tooltip
 * library — this is deliberately the cheapest possible implementation.
 */
import type { JSX } from 'react';
import { Icon } from './Icon.js';

export function InlineHelp({ text }: { text: string }): JSX.Element {
  return (
    <button type="button" className="inline-help" title={text} aria-label={text}>
      <Icon name="help" size="sm" />
    </button>
  );
}
